import SliderController from '../modules/SliderController';
import ScrollController from '../util/ScrollController';
import Tabs from '../modules/Tabs';

export default {
  init() {
    // JavaScript to be fired on all pages
    const scrollControll = new ScrollController();
    scrollControll.setEventListener();
    new SliderController();
    new Tabs();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js